import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const ImessageScaleSmall = hoc(
    (props: IconProps) => (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M7.99992 2C6.23181 2.00001 4.53613 2.58801 3.28589 3.63466C2.03565 4.68131 1.33326 6.10087 1.33325 7.58105C1.33486 8.54383 1.63396 9.48989 2.20148 10.3273C2.76899 11.1647 3.58562 11.8649 4.57201 12.36C4.3093 12.9511 3.91529 13.5054 3.40629 14C4.39335 13.8258 5.31993 13.46 6.11391 12.9309C6.72611 13.0832 7.36127 13.1611 7.99992 13.1621C9.76803 13.1621 11.4637 12.5741 12.714 11.5274C13.9642 10.4808 14.6666 9.06123 14.6666 7.58105C14.6666 6.10087 13.9642 4.68131 12.714 3.63466C11.4637 2.58801 9.76803 2.00001 7.99992 2Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Imessage'
);
export default ImessageScaleSmall;
